import { lazy } from 'react';

const RecipeCalculationsDefaultView = lazy(
  () => import('./default-view/RecipeCalculationsDefaultView'),
);

export const RecipeCalculationsPage = () => <RecipeCalculationsDefaultView />;
